import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

export interface ReporteHistoricoData {
  inscricaoId: number
  inscricaoDocumentoId?: number
  status: string
  reportadoPor: string
  nomeReportador: string | null
  reportadoEm: string
  tipoReportador: string
  justificativaReporte: string | null
  decididoPor: string | null
  nomeDecididor: string | null
  decididoEm: string | null
  justificativaDecisao: string | null
}

export interface ReporteHistoricoDialogInput {
  reportes: ReporteHistoricoData | ReporteHistoricoData[]
  mostrarIndice?: boolean
  isPresidente?: boolean
  concursoId?: number
}

@Component({
  selector: 'app-reporte-historico-dialog',
  templateUrl: './reporte-historico-dialog.component.html',
  styleUrls: ['./reporte-historico-dialog.component.scss'],
})
export class ReporteHistoricoDialogComponent {
  reportes: ReporteHistoricoData[] = []
  mostrarIndice: boolean = false
  isPresidente: boolean = false
  concursoId?: number
  temPendente: boolean = false

  constructor(
    public dialogRef: MatDialogRef<ReporteHistoricoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ReporteHistoricoDialogInput | ReporteHistoricoData | ReporteHistoricoData[]
  ) {
    if (data && 'reportes' in data) {
      this.reportes = Array.isArray(data.reportes) ? data.reportes : [data.reportes]
      this.mostrarIndice = !!data.mostrarIndice
      this.isPresidente = !!data.isPresidente
      this.concursoId = data.concursoId
    } else {
      this.reportes = Array.isArray(data) ? data : [data]
    }
    this.temPendente = this.reportes.some(r => r.status === 'PENDENTE')
  }

  getStatusLabel(status: string): string {
    switch (status) {
      case 'PENDENTE': return 'Pendente de decisão'
      case 'DEFERIDA': return 'Deferida — Candidato desclassificado'
      case 'INDEFERIDA': return 'Indeferida — Prova restabelecida'
      default: return status
    }
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'PENDENTE': return 'status-pendente'
      case 'DEFERIDA': return 'status-deferida'
      case 'INDEFERIDA': return 'status-indeferida'
      default: return ''
    }
  }

  getTipoReportadorLabel(tipo: string): string {
    return tipo === 'ADMIN' ? 'Administrador' : 'Examinador'
  }
}
